class CanadaPostQueryParams {
    public SearchTerm: string = "";
    public LastId: string = "";
    public Key: string = process.env.REACT_APP_CANADA_POST_API_KEY;
    public Country: string = "CAN";
    public SearchFor: string = "Everything";
    public LanguagePreference: string = sessionStore.getUserLanguageCodeFRorEN();
    public OrderBy: string = "UserLocation";
    public block: boolean = true;
    public cache: boolean = true;
    public MaxSuggestions: number = 7;
    public MaxResults: number = 100;

    public constructor(params: Partial<CanadaPostQueryParams>) {
        Object.assign(this, params);
    }

    public static defaultWithSearchTerm(searchTerm: string): CanadaPostQueryParams {
        return new CanadaPostQueryParams({ SearchTerm: searchTerm });
    }

    public static defaultWithLastId(lastId: string): CanadaPostQueryParams {
        return new CanadaPostQueryParams({ LastId: lastId });
    }
}

export { CanadaPostQueryParams };
